import { Flex } from '@components/Flex';
import { TenantLogo } from '@connect-carrier/components/TenantLogo';
import { CustomerListOutput } from '@connect-carrier/hooks/useFetchCustomerList';
import { useFlagMe480232CarrierPortalNavigationBrandingSearchFe } from '@generated/flags/ME-480232-carrier-portal-navigation-branding-search-fe';
import { FC } from 'react';

// ts-unused-exports:disable-next-line
export interface CustomerListProps {
  customers: ReadonlyArray<CustomerListOutput>;
  handleCustomerSelect: (customer: CustomerListOutput) => void;
}

// ts-unused-exports:disable-next-line
export const CustomerList: FC<CustomerListProps> = ({
  customers,
  handleCustomerSelect,
}) => {
  const enableNavigationBrandingSearchFe =
    useFlagMe480232CarrierPortalNavigationBrandingSearchFe();

  return (
    <>
      <ul
        css={{
          padding: 0,

          maxHeight: 250,
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            width: 4,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0, 0, 0, 0.5)',
          },
        }}
        data-testid="customers-list"
      >
        {customers.map((customer) => (
          <div
            key={customer.tenantId}
            css={{
              padding: 10,
              cursor: 'pointer',
              '&:hover': {
                background: '',
              },
            }}
            data-testid={`customer-${customer.tenantId}`}
            onClick={() => {
              handleCustomerSelect(customer);
            }}
          >
            <Flex
              css={{
                alignItems: 'center',
              }}
            >
              <div
                css={{
                  height: 30,
                  width: 30,
                  padding: 0,
                }}
                data-testid={`customer-img-${customer.tenantId}`}
              >
                {enableNavigationBrandingSearchFe ? (
                  <TenantLogo
                    tenantCode={customer.tenantCode}
                    altText={customer.displayName}
                    width="30px"
                    height="30px"
                    testId={`customer-logo-${customer.tenantId}`}
                  />
                ) : (
                  <img
                    src={`data:image/png;base64, ${customer.tenantImage}`}
                    alt={`${customer.tenantName}`}
                    css={{
                      width: '100%',
                      maxWidth: '300px',
                    }}
                  />
                )}
              </div>
              <div>{customer.displayName}</div>
            </Flex>
          </div>
        ))}
      </ul>
    </>
  );
};
